/**
 * Normalize batch detail payloads from GET /api/batches/:id (axios or react-query).
 */
export function unwrapBatchDetail(responseOrData) {
  if (!responseOrData) return null;
  if (responseOrData.data?.data != null && responseOrData.data?.success !== undefined) {
    return responseOrData.data.data;
  }
  if (responseOrData.data != null && responseOrData.success !== undefined) {
    return responseOrData.data;
  }
  return responseOrData;
}

export function getBatchStudents(batch) {
  return Array.isArray(batch?.students) ? batch.students : [];
}

export function formatBatchStudentName(student) {
  const name = String(student?.student_name || '').trim();
  return name || student?.student_email || 'Unnamed student';
}

export function resolveBatchStudentCount(batch) {
  if (!batch) return 0;
  if (batch.actual_student_count != null) return batch.actual_student_count;
  return getBatchStudents(batch).length;
}

/** GET /api/batches/:id/students → data.students */
export function unwrapBatchStudentsList(responseOrData) {
  const payload = unwrapBatchDetail(responseOrData);
  if (payload?.students) return payload.students;
  return [];
}

function rosterRowFromSessionStudent(row, eligible) {
  return {
    student_id: row.student_id,
    student_name: formatBatchStudentName(eligible || row),
    student_display_id: row.student_display_id || row.display_id || eligible?.student_display_id || null,
    attendanceStatus: eligible?.attendanceStatus ?? row.attendanceStatus ?? null,
    classesCompleted: eligible?.classesCompleted ?? row.classesCompleted ?? 0,
    progressDenominator: eligible?.progressDenominator ?? row.progressDenominator ?? 0,
    progressWindowStart: eligible?.progressWindowStart ?? row.progressWindowStart ?? null,
    progressWindowEnd: eligible?.progressWindowEnd ?? row.progressWindowEnd ?? null,
    timezone: row.timezone || eligible?.timezone || null,
    country: row.country || eligible?.country || null,
    plannedLeave: !!(eligible?.plannedLeave ?? row.plannedLeave),
    mergedIn: !!(eligible?.mergedIn ?? row.mergedIn),
    sourceBatchId: eligible?.sourceBatchId || row.sourceBatchId || null,
    sourceBatchName: eligible?.sourceBatchName || row.sourceBatchName || null,
    attendanceSessionId: eligible?.attendanceSessionId || row.attendanceSessionId || null,
    sessionEligible: eligible ? eligible.sessionEligible !== false : false,
  };
}

/**
 * Session detail only returns students eligible for that class date.
 * Merge with the full batch roster for display, and keep children who joined
 * from another batch (they are on the session list, not the host roster).
 */
export function mergeBatchRosterForSessionDisplay(batchStudents, sessionStudents) {
  const eligibleById = new Map((sessionStudents || []).map((s) => [String(s.student_id), s]));
  const roster = batchStudents?.length ? batchStudents : [];
  const seen = new Set();
  const rows = roster.map((row) => {
    const id = String(row.student_id);
    seen.add(id);
    return rosterRowFromSessionStudent(row, eligibleById.get(id));
  });
  for (const extra of sessionStudents || []) {
    const id = String(extra.student_id);
    if (seen.has(id)) continue;
    seen.add(id);
    rows.push(rosterRowFromSessionStudent(extra, extra));
  }
  return rows;
}
